import React from 'react';

const TransmissionFilterIcon = (props: any) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="5.1" y1="19.1" x2="5.1" y2="5.9" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="12.1" y1="19.1" x2="12.1" y2="5.9" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M6 13H19V9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="19" cy="6" r="2.1" fill="transparent" strokeWidth="1.8" />
    <circle cx="12" cy="6" r="2" fill={props.fill || '#000000'} />
    <circle cx="12" cy="20" r="2" fill={props.fill || '#000000'} />
    <circle cx="5" cy="6" r="2" fill={props.fill || '#000000'} />
    <circle cx="5" cy="20" r="2" fill={props.fill || '#000000'} />
  </svg>
);

export default TransmissionFilterIcon;
